import DownloadApp from "@/components/DownloadApp";
import MetaSeo from "@/components/Head/Meta";
import AllenDNLogo from "@/components/SVG/AllenDNLogo";
import { STATIC_CDN_IMAGES } from "@/config/constants";
import Image from "next/image";

const OnlineStudyApp = () => {

  return (
    <>
      <MetaSeo title="Doubtnut App - Instant Doubt Solving for Maths, Science, IIT-JEE & NEET | Download Now" description="Download Doubtnut App for instant solutions to Maths, Science, IIT-JEE, and NEET doubts. Access live classes, NCERT books, and past papers. Ideal for Class 6-12" />

      <div className='justify-around my-10 max-w-6xl mx-auto p-2'>
        <div className='flex flex-col items-center gap-12'>
          <div className='flex flex-wrap'>
            <div className='flex flex-col items-center gap-4  lg:w-1/2 grow'>
              <div className='w-full text-5xl lg:text-6xl text-center font-semibold flex flex-col gap-2'>
                <AllenDNLogo className='inline-block h-12' />
                <div> is available on&nbsp;</div>
                <div className='text-blue-500'>all platforms</div>
              </div>
              <div className='w-3/4 p-12 fill-body'>
                <svg
                  version='1.1'
                  id='Layer_1'
                  xmlns='http://www.w3.org/2000/svg'
                  xmlnsXlink='http://www.w3.org/1999/xlink'
                  x='0px'
                  y='0px'
                  viewBox='0 0 122.88 86.686'
                  enable-background='new 0 0 122.88 86.686'
                  xmlSpace='preserve'
                >
                  <g>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M53.995,73.994h25.399c0.064,4.396,1.872,8.325,6.783,11.429H47.22 C51.14,82.576,54.013,79.116,53.995,73.994L53.995,73.994L53.995,73.994L53.995,73.994z M41.118,30.451v53.131 c0,1.012-0.829,1.841-1.84,1.841H1.841C0.829,85.423,0,84.594,0,83.582V30.451c0-1.011,0.829-1.84,1.841-1.84h37.432 C40.289,28.611,41.118,29.439,41.118,30.451L41.118,30.451L41.118,30.451z M20.557,79.303c1.164,0,2.11,0.945,2.11,2.109 s-0.946,2.11-2.11,2.11s-2.11-0.946-2.11-2.11C18.452,80.248,19.393,79.303,20.557,79.303L20.557,79.303L20.557,79.303z M38.622,31.895v45.537H2.755V31.895H38.622L38.622,31.895L38.622,31.895z M102.54,44.215h15.942c1.213,0,2.32,0.495,3.109,1.29 c0.8,0.801,1.288,1.902,1.288,3.109v33.673c0,1.214-0.494,2.321-1.288,3.109c-0.802,0.802-1.902,1.289-3.109,1.289H102.54 c-1.214,0-2.321-0.494-3.109-1.289c-0.801-0.8-1.289-1.901-1.289-3.109V48.608c0-1.214,0.494-2.321,1.289-3.11 C100.231,44.698,101.326,44.215,102.54,44.215L102.54,44.215L102.54,44.215z M99.657,80.576h21.701V49.012H99.657V80.576 L99.657,80.576z M110.505,81.952c0.995,0,1.808,0.801,1.808,1.808c0,0.996-0.801,1.809-1.808,1.809 c-0.995,0-1.809-0.801-1.809-1.809C108.696,82.766,109.497,81.952,110.505,81.952L110.505,81.952L110.505,81.952z M17.5,0h97.411 c1.542,0,2.8,1.257,2.8,2.8v31.73h-3.976V6.268c0-1.359-1.11-2.479-2.479-2.479H21.145l0,0c-1.359,0-2.479,1.11-2.479,2.479v16.178 H14.7V2.8C14.7,1.257,15.958,0,17.5,0L17.5,0L17.5,0L17.5,0z M47.03,60.417h45.478v9.713H47.03V60.417L47.03,60.417z'
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className='w-full lg:w-1/2 grow'>
              <Image
                src={`${STATIC_CDN_IMAGES}/mweb-new-download-app-main-image.png`}
                width={834}
                height={582}
                alt={"mweb-new-download-app-main-image"}
                className="my-0"
              />
            </div>
          </div>
          <DownloadApp />
        </div>
      </div>
    </>
  );
};

export default OnlineStudyApp;
